<template>
  <b-modal
    id="promo-zero-modal"
    no-close-on-backdrop
    no-close-on-esc
    hide-header
    hide-header-close
    hide-footer
  >
    <p class="my-4">
      <slot />
    </p>

    <div class="row">
      <button
        size="sm"
        class="btn btn-outline-secondary rg-border-radius mx-auto"
        @click="clickAcknowledge"
      >
        {{ acknowledge }}
      </button>
    </div>
  </b-modal>
</template>

<script>
  export default {
    props: {
      acknowledge: {
        default: 'Acknowledge',
        required: false,
        type: String
      }
    },

    methods: {
      clickAcknowledge () {
        this.$emit('acknowledged');
      }
    }
  };
</script>
